@if (!isMobile) {
  <div class="create-workplan">
    <app-workplans-popup-approval [hidden]='!showWorkplanPopupApproval' (approveCancelChangesEmitter)="approveCancelWorkplanChanges($event)"></app-workplans-popup-approval>
    <div class='create-new-workplan-modal-wrapper'>
      <div class='main-title'>{{ 'NEW_WORKPLAN.SCHEDULE_WORKPLAN' | translate }}</div>
      <div class='new-workplan-data-wrapper'>
        <div class='subsites-wrapper' rtlDiv>
          <div class='workplan-subtitle' rtlDiv>{{ 'NEW_WORKPLAN.SITES' | translate }}</div>
          <mat-form-field class='workplan-input workplan-drop-down' rtlDiv>
            <mat-label rtlDiv [hidden]="selectedSites != null && selectedSites.length != 0" class="placeholder">{{ 'NEW_WORKPLAN.CHOOSE_SITE' | translate }}</mat-label>
            <mat-select panelClass="period-class" class="select-options" #siteMatSelect (valueChange)="chooseSite($event)" [(value)]="selectedSites" name="site" multiple>
              <div class='search-input-container' rtlDiv>
                <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchSites($event.target)" rtlDiv>
              </div> 
              @if(sitesListData?.length > 1) {
                <div class="select-all" rtlDiv>
                  <mat-checkbox [(ngModel)]="allSiteSelected" (change)="toggleAllSiteSelection()">
                    <span class="option-item">{{ 'WORKPLAN.ALL_SITES' | translate }}</span>
                  </mat-checkbox>
                </div>
              }
              @for (item of sitesListData; track item) {
                <mat-option [value]="item" rtlDiv>
                  <span rtlDiv class="option-item">{{item.site_name}}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="error-container">
            <div class='time-invalid-text' [hidden]='!this.sitesErrorFlag'>{{ 'NEW_WORKPLAN.SITE_ERROR' | translate }}</div>
          </div>
        </div>
        <div class='truck-wrapper' rtlDiv>
          <div class='workplan-subtitle'>{{ 'NEW_WORKPLAN.TRUCKS' | translate }}</div>
          <mat-form-field class='workplan-input workplan-drop-down' rtlDiv>
            <mat-label rtlDiv [hidden]="selectedTrucks != null && selectedTrucks.length != 0" class="placeholder">{{ 'NEW_WORKPLAN.CHOOSE_TRUCK' | translate }}</mat-label>
            <mat-select panelClass="period-class" class="select-options" #truckMatSelect [(value)]="selectedTrucks" name="collection" multiple>
              <div class='search-input-container' rtlDiv>
                <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchTrucks($event.target)" rtlDiv>
              </div> 
              @if(trucksListDataToShow?.length > 1) {
                <div class="select-all" rtlDiv>
                  <mat-checkbox [(ngModel)]="allTruckSelected" (change)="toggleAllTruckSelection()">
                    <span class="option-item">{{ 'WORKPLAN.ALL_TRUCKS' | translate }}</span>
                  </mat-checkbox>
                </div>
              }
              @for (item of trucksListDataToShow; track item) {
                <mat-option [value]="item" rtlDiv (click)="truckOptionClick()">
                  <div rtlDiv class="flex-between">
                    <div class="option-item">{{ 'NEW_WORKPLAN.TRUCK' | translate }}_{{item.tablet_id}}</div>
                    <div class="option-item">({{item.site_name}})</div>
                  </div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class='time-invalid-text' [hidden]='!trucksErrorFlag'>{{ 'NEW_WORKPLAN.TRUCK_ERROR' | translate }}</div>
          <div class='time-invalid-text' [hidden]='!missingSiteSelection'>{{ 'NEW_WORKPLAN.MISSING_SITE_SELECTION_ERROR' | translate }}</div>
        </div>
        <div class='daytime-wrapper dflex' rtlDiv>
          <mat-card class="card-date">
            <mat-card-content>
              <div class='workplan-subtitle flex-gap'>
                <img src="assets/images/workplans-page/calendar-icon.svg" alt="arrow">
                <div>{{ 'NEW_WORKPLAN.DATE' | translate }}</div>
              </div>
              <div class='datepicker-wrapper' rtlDiv #datepickerWrapper>
                <div class='selected-dates'>
                  <div class='dates-range datepicker-rtl' rtlDiv>
                    {{dateLbl}}                    
                  </div>
                </div>
                <div class="datepicker-rtl">
                  <app-datepicker-custom [hidden]='!showDatePicker' (selectDates)='onSelectDates($event)'></app-datepicker-custom>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <div class='time-wrapper' rtlDiv>
            <div class='workplan-subtitle flex-gap'>
              <img src="assets/images/workplans-page/time-icon.svg" alt="arrow">
              <div>{{ 'NEW_WORKPLAN.TIME' | translate }}</div>              
            </div>
            <div class='time-btns-container' rtlDiv>
              <div class='time-btn left'>
                {{selectedWorkplanTime.hour}}
                <img class='time-down-arrow-img' src="assets/images/workplans-page/down_arrow_icon.svg" alt="arrow">
                @if (!closeHour) {
                  <div [hidden]='!showHideDropdownLists.timeHour' class='time-dropdown-container'>
                    <div class="time-dropdown-list">
                      @for (item of workplanTime.hours; track item) {
                        <div class="drop-down-list-item time-list" (click)="selectWorkplanTime(item, 'hour')">
                          {{item}}
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class='time-icon'>:</div>
              <div class='time-btn right'>
                {{selectedWorkplanTime.minute}}
                <img class='time-down-arrow-img' src="assets/images/workplans-page/down_arrow_icon.svg" alt="arrow">
                @if (!closeMinute) {
                  <div [hidden]='!showHideDropdownLists.timeMinute' class='time-dropdown-container'>
                    <div class="time-dropdown-list">
                      @for (item of workplanTime.minutes; track item) {
                        <div class="drop-down-list-item time-list" (click)="selectWorkplanTime(item, 'minute')">
                          {{item}}
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class='time-invalid-text' [hidden]='!showTimeErrorText' rtlDiv>{{ 'NEW_WORKPLAN.INVALID_TIME_ERROR' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class='main-btns-wrapper' rtlDiv>
      <div class='cancel-btn' (click)="closeModal()" rtlDiv>{{ 'NEW_WORKPLAN.CANCEL' | translate }}</div>
      <div class='apply-btn' (click)='saveWorkplan()' rtlDiv>{{ 'NEW_WORKPLAN.APPLY_WORKPLAN' | translate }}</div>
    </div>
  </div>
}

@if (isMobile) {
  <div class="create-workplan mobile-create-workplan">
    <app-workplans-popup-approval [hidden]='!showWorkplanPopupApproval' (approveCancelChangesEmitter)="approveCancelWorkplanChanges($event)"></app-workplans-popup-approval>
    <div class="mobile-modal-title" rtlDiv>
      <div class="dflex" (click)="closeModal()">
        <img [ngClass]="{'rotate-arrow':currentLang == 'iw'}" src="assets/images/sidemenu/back-arrow.svg" alt=""/>
      </div>
      <div>
        <span class="main-title">{{ 'NEW_WORKPLAN.SCHEDULE_WORKPLAN' | translate }}</span>
      </div>
    </div>
    <div class="mobile-popup-container">
      <div class="mobile-prop-frame">
        <div class="days-between-container">
          <div class="add-ticket-form">
            <div class="events-type-container">
              <div class="grid-view" rtlDiv>
                <div class='mobile-sub-title' rtlDiv>{{ 'NEW_WORKPLAN.SITES' | translate }}</div>
                <mat-form-field class='event-type-input event-types' rtlDiv>
                  <mat-label rtlDiv [hidden]="selectedSites != null && selectedSites.length != 0" class="placeholder">{{ 'NEW_WORKPLAN.CHOOSE_SITE' | translate }}</mat-label>
                  <mat-select panelClass="period-class" disableOptionCentering class="select-options" #siteMatSelect (valueChange)="chooseSite($event)" [(value)]="selectedSites" name="site" multiple>
                    @if(sitesListData?.length > 1) {
                      <div class="select-all" rtlDiv>
                        <mat-checkbox [(ngModel)]="allSiteSelected" (change)="toggleAllSiteSelection()">
                          <span class="option-item">{{ 'WORKPLAN.ALL_SITES' | translate }}</span>
                        </mat-checkbox>
                      </div>
                    }
                    @for (item of sitesListData; track item) {
                      <mat-option [value]="item" rtlDiv>
                        <span rtlDiv class="option-item">{{item.site_name}}</span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div class="mobile-error-container">
                  <div class='time-invalid-text' [hidden]='!this.sitesErrorFlag'>{{ 'NEW_WORKPLAN.SITE_ERROR' | translate }}</div>
                </div>
              </div>
              <div class="grid-view" rtlDiv>
                <div class='mobile-sub-title'>{{ 'NEW_WORKPLAN.TRUCKS' | translate }}</div>
                <mat-form-field class='event-type-input event-types' rtlDiv>
                  <mat-label rtlDiv [hidden]="selectedTrucks != null && selectedTrucks.length != 0" class="placeholder">{{ 'NEW_WORKPLAN.CHOOSE_TRUCK' | translate }}</mat-label>
                  <mat-select panelClass="period-class" disableOptionCentering class="select-options" #truckMatSelect [(value)]="selectedTrucks" name="collection" multiple>
                    @if(trucksListDataToShow?.length > 1) {
                      <div class="select-all" rtlDiv>
                        <mat-checkbox [(ngModel)]="allTruckSelected" (change)="toggleAllTruckSelection()">
                          <span class="option-item">{{ 'WORKPLAN.ALL_TRUCKS' | translate }}</span>
                        </mat-checkbox>
                      </div>
                    }
                    @for (item of trucksListDataToShow; track item) {
                      <mat-option [value]="item" rtlDiv (click)="truckOptionClick()">
                        <div rtlDiv class="flex-between">
                          <div class="option-item">{{ 'NEW_WORKPLAN.TRUCK' | translate }}_{{item.tablet_id}}</div>
                          <div class="option-item">({{item.site_name}})</div>
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div class='time-invalid-text' [hidden]='!trucksErrorFlag'>{{ 'NEW_WORKPLAN.TRUCK_ERROR' | translate }}</div>
                <div class='time-invalid-text' [hidden]='!missingSiteSelection'>{{ 'NEW_WORKPLAN.MISSING_SITE_SELECTION_ERROR' | translate }}</div>
              </div>
              <div class='daytime-wrapper dflex' rtlDiv>
                <mat-card class="card-date">
                  <mat-card-content class="mat-card-content-date">
                    <div class='mobile-sub-title'>{{ 'NEW_WORKPLAN.DATE' | translate }}</div>
                    <div class='datepicker-wrapper' rtlDiv #datepickerWrapper>
                      <div class='selected-dates'>
                        <div class='mobile-dates-range datepicker-rtl' rtlDiv>
                          {{dateLbl}}
                        </div>
                        <img class='dropdown-icon' src="assets/images/dashboard/dropdown_arrow.svg" alt="dropdown_arrow">
                      </div>
                      <div class="datepicker-rtl">
                        <app-datepicker-custom [hidden]='!showDatePicker' (selectDates)='onSelectDates($event)'></app-datepicker-custom>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
                <div class='time-wrapper period-list' rtlDiv>
                  <div class='mobile-sub-title'>{{ 'NEW_WORKPLAN.TIME' | translate }}</div>
                  <div class='time-btns-container' rtlDiv>
                    <div class='time-btn left'>
                      {{selectedWorkplanTime.hour}}
                      @if (!closeHour) {
                        <div [hidden]='!showHideDropdownLists.timeHour' class='mobile-time-dropdown-container'>
                          @for (item of workplanTime.hours; track item) {
                            <div class="drop-down-list-item time-list" (click)="selectWorkplanTime(item, 'hour')">
                              {{item}}
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div class='time-icon'>:</div>
                    <div class='time-btn right'>
                      {{selectedWorkplanTime.minute}}
                      @if (!closeMinute) {
                        <div [hidden]='!showHideDropdownLists.timeMinute' class='mobile-time-dropdown-container'>
                          @for (item of workplanTime.minutes; track item) {
                            <div class="drop-down-list-item time-list" (click)="selectWorkplanTime(item, 'minute')">
                              {{item}}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class='time-invalid-text' [hidden]='!showTimeErrorText' rtlDiv>{{ 'NEW_WORKPLAN.INVALID_TIME_ERROR' | translate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='main-btns-wrapper' rtlDiv>
        <div class='btns-container' rtlDiv>
          <div class='mobile-cancel_btn' (click)="closeModal()" rtlDiv>{{ 'NEW_WORKPLAN.CANCEL' | translate }}</div>
          <div [ngClass]="{'mobile-apply-btn':selectedSites.length > 0 && selectedTrucks.length > 0,'mobile-not-apply-btn':selectedSites.length == 0 || selectedTrucks.length == 0}" (click)='saveWorkplan()' rtlDiv>{{ 'NEW_WORKPLAN.APPLY_WORKPLAN' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
}
